import { dealTypeFromJsonQuery, FDealType, getRangeValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { fillLabelTemplate } from '../../utils/fillLabelTemplate';

const ID = 'site' as const;

export const landAreaTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const landArea = getRangeValue('site')(jsonQuery);

    if (landArea === null || dealType !== FDealType.RentLongterm) {
      return null;
    }

    const { gte, lte } = landArea;
    const from = gte ? `от ${gte}` : '';
    const to = lte ? `до ${lte}` : '';

    return [{ label: fillLabelTemplate(`Площадь участка %s сот.`, `${from} ${to}`).trim(), value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['foot_min', 'only_foot'])(jsonQuery),
};
